// Shared confirm-dialog phrase for the stocktake bulk zero action, so the web and
// driver app copy cannot drift ("the 1 uncounted product" / "all N uncounted products").
import { formatNumber } from '../utils';

export const formatUncountedProductsPhrase = (count) => {
	return count === 1 ? 'the 1 uncounted product' : `all ${formatNumber(count)} uncounted products`;
};
